export default ({ authGuard, guestGuard }) => [
    { path: '/', name: 'welcome', component: require('~/pages/welcome.vue') },

    //{ path: '/', name: 'welcome', component: require('~/pages/auth/login.vue') },

    // Authenticated routes.
    ...authGuard([
        //{ path: '/home', name: 'home', component: require('~/pages/home.vue') },
        {
            path: '/settings',
            component: require('~/pages/shared/settings/index.vue'),
            children: [
                { path: '', redirect: { name: 'settings.profile' } },
                { path: 'profile', name: 'settings.profile', component: require('~/pages/shared/settings/profile.vue') },
                { path: 'password', name: 'settings.password', component: require('~/pages/shared/settings/password.vue') }
            ]
        },
        {
            path: '/admin',
            component: require('~/pages/admin/index.vue'),
            children: [
                { path: '', redirect: { name: 'admin.dashboard' } },
                { path: 'dashboard', name: 'admin.dashboard', component: require('~/pages/admin/dashboard.vue') },
                { path: 'students', name: 'admin.students', component: require('~/pages/admin/students/students.vue') },
                { path: 'classes', name: 'admin.classes', component: require('~/pages/admin/classes/classes.vue') },
                { path: 'fees', name: 'admin.fees', component: require('~/pages/shared/fees/fees.vue') },
                { path: 'guardians', name: 'admin.guardians', component: require('~/pages/admin/guardians/guardians.vue') },
                { path: 'employees', name: 'admin.employees', component: require('~/pages/admin/employees/employees.vue') },
                { path: 'setts', name: 'admin.setts', component: require('~/pages/shared/settings/settings.vue') },
                { path: 'bulksms', name: 'admin.bulksms', component: require('~/pages/admin/bulksms/bulksms.vue') },
            ]
        },
        {
            path: '/teacher',
            component: require('~/pages/teacher/index.vue'),
            children: [
                { path: '', redirect: { name: 'teacher.dashboard' } },
                { path: 'dashboard', name: 'teacher.dashboard', component: require('~/pages/teacher/dashboard.vue') },
                { path: 'students', name: 'teacher.students', component: require('~/pages/teacher/students/students.vue') },
                { path: 'attendance', name: 'teacher.attendance', component: require('~/pages/teacher/attendance/attendance.vue') },
                { path: 'assessment', name: 'teacher.assessment', component: require('~/pages/teacher/assessment/assessment.vue') },
                { path: 'my_account', name: 'teacher.account', component: require('~/pages/shared/settings/profile.vue') },
            ]
        },
        {
            path: '/guardian',
            component: require('~/pages/guardian/index.vue'),
            children: [
                { path: '', redirect: { name: 'guardian.dashboard' } },
                { path: 'dashboard', name: 'guardian.dashboard', component: require('~/pages/guardian/dashboard.vue') },
                { path: 'wards', name: 'guardian.wards', component: require('~/pages/guardian/wards/wards.vue') },
                { path: 'my_account', name: 'guardian.account', component: require('~/pages/shared/settings/profile.vue') },
            ]
        },
        {
            path: '/accountant',
            component: require('~/pages/accountant/index.vue'),
            children: [
                { path: '', redirect: { name: 'accountant.dashboard' } },
                { path: 'dashboard', name: 'accountant.dashboard', component: require('~/pages/accountant/dashboard.vue') },
                { path: 'fees', name: 'accountant.fees', component: require('~/pages/accountant/fees/fees.vue') },
                { path: 'payroll', name: 'accountant.payroll', component: require('~/pages/accountant/payroll/payroll.vue') },
                { path: 'income', name: 'accountant.income', component: require('~/pages/accountant/income/income.vue') },
                { path: 'expenses', name: 'accountant.expenses', component: require('~/pages/accountant/expenses/expenses.vue') },
                { path: 'billings', name: 'accountant.billing', component: require('~/pages/accountant/billing/billing.vue') },
                { path: 'banking', name: 'accountant.banking', component: require('~/pages/accountant/banking/banking.vue') },
                { path: 'reports', name: 'accountant.reports', component: require('~/pages/accountant/reports/report.vue') },
                { path: 'my_account', name: 'accountant.account', component: require('~/pages/shared/settings/profile.vue') },
            ]
        }

    ]),

    // Guest routes.
    ...guestGuard([
        // { path: '/login', name: 'login', component: require('~/pages/auth/login.vue') },
        // { path: '/bof', name: 'backOffice', component: require('../pages/auth/adminlogin.vue') },
        { path: '/register', name: 'register', component: require('~/pages/auth/register.vue') },
        { path: '/password/reset', name: 'password.request', component: require('~/pages/auth/password/email.vue') },
        { path: '/password/reset/:token', name: 'password.reset', component: require('~/pages/auth/password/reset.vue') }
    ]),

    // { path: '*', component: require('~/pages/errors/404.vue') }
    { path: '*', component: require('~/pages/welcome.vue') }
]



// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js